import {
  PAYFAST_PAY_REQUEST,
  PAYFAST_PAY_SUCCESS,
  PAYFAST_PAY_FAIL,
  PAYFAST_PAY_RESET,
  PAYFAST_ACTION_REQUEST,
  PAYFAST_ACTION_SUCCESS,
  PAYFAST_ACTION_FAIL,
  PAYFAST_ACTION_RESET,
  PAYFAST_SIGNATURE_REQUEST,
  PAYFAST_SIGNATURE_SUCCESS,
  PAYFAST_SIGNATURE_FAIL,
} from "../Constants/PaymentConstants";

// PAYFAST EXECUTE
export const payfastExecuteReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYFAST_PAY_REQUEST:
      return { loading: true };
    case PAYFAST_PAY_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case PAYFAST_PAY_FAIL:
      return { loading: false, error: action.payload };
    case PAYFAST_PAY_RESET:
      return {};
    default:
      return state;
  }
};

// PAYFAST CANCEL
export const paymentSubscriptionActionReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYFAST_ACTION_REQUEST:
      return { loading: true };
    case PAYFAST_ACTION_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case PAYFAST_ACTION_FAIL:
      return { loading: false, error: action.payload };
    case PAYFAST_ACTION_RESET:
      return {};
    default:
      return state;
  }
};

// PAYFAST SIGNATURE
export const payfastSignatureReducer = (state = {}, action) => {
  switch (action.type) {
    case PAYFAST_SIGNATURE_REQUEST:
      return { loading: true };
    case PAYFAST_SIGNATURE_SUCCESS:
      return { loading: false, success: true, signature: action.payload };
    case PAYFAST_SIGNATURE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
